import angular  from 'angular'
import uiRouter from 'angular-ui-router'

import component from './maintenance.component'

let module = angular.module('maintenancePage', [
  uiRouter
])

.config(($stateProvider) => {
  'ngInject'
  $stateProvider
    .state('maintenance', {
      url: '/maintenance?token',
      component: 'maintenance'
    })
})

.component('maintenance', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/maintenance/index.js